import React from 'react';
import './Header.css';
import mp4 from './../../video/header_bg.mp4';
import logo from './../../awesom/laptop.svg';
import poster from './../../video/header_bg.jpg';

const Header = () => {
	return (
		<div className="header">	
			<h1>Web Developer</h1>
			<video className="header_bg" loop autoPlay poster={poster}>
				<source src={mp4} type="video/mp4" />
			</video>
		</div>
		)
}
export default Header;